import * as React from "react";

import { Backdrop, Box, CircularProgress, Stack } from "@mui/material";

type LoadingPageProps = {
  children?: React.ReactNode;
};

export function LoadingPageLayout(props: LoadingPageProps): JSX.Element {
  return (
    <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={true}>
      <Box display="flex" width={500} height={80}>
        <Box m="auto">
          <Stack>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <CircularProgress color="inherit" />
            </div>

            {props.children}
          </Stack>
        </Box>
      </Box>
    </Backdrop>
  );
}
